import type { IStatistics } from '@/Module/Workspace/Model/DataModel';

export const FAKE_DATA: Omit<IStatistics, 'bookCategories'>[] = [
  { id: 1, bookId: 1, bookName: 'شیمی', bookWatchedCount: 30 },
  { id: 2, bookId: 2, bookName: 'فیزیک', bookWatchedCount: 10 },
  { id: 3, bookId: 3, bookName: 'ریاضی', bookWatchedCount: 40 },
  { id: 4, bookId: 4, bookName: 'علوم', bookWatchedCount: 60 },
  { id: 5, bookId: 5, bookName: 'ادبیات', bookWatchedCount: 70 },
];
